import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

// Default package used whenever a lead is submitted without first selecting
// a pricing package (hero forms, header/footer CTAs, generic popups, etc.)
export const DEFAULT_PACKAGE = {
  packageTitle: "Basic Package",
  packageAmount: "$45",
};

// tmSignUpType mapping:
// 1 = Self Filing with Assistance
// 2 = IP Attorney-Led Filing
const PricingContext = createContext(null);

export const PricingProvider = ({ children }) => {
  const [activePricingTab, setActivePricingTab] = useState(1);
  const [selectedPackage, setSelectedPackageState] = useState(null);

  const setSelectedPackage = useCallback((pkg, tab) => {
    if (tab) setActivePricingTab(tab);
    setSelectedPackageState(pkg);
  }, []);

  const resetSelectedPackage = useCallback(() => {
    setSelectedPackageState(null);
  }, []);

  const value = useMemo(() => {
    const packageTitle = selectedPackage?.packageTitle || DEFAULT_PACKAGE.packageTitle;
    const packageAmount = selectedPackage?.packageAmount || DEFAULT_PACKAGE.packageAmount;
    return {
      activePricingTab,
      setActivePricingTab,
      selectedPackage,
      setSelectedPackage,
      resetSelectedPackage,
      tmSignUpType: activePricingTab,
      packageTitle,
      packageAmount,
    };
  }, [activePricingTab, selectedPackage, setSelectedPackage, resetSelectedPackage]);

  return (
    <PricingContext.Provider value={value}>{children}</PricingContext.Provider>
  );
};

export const usePricing = () => useContext(PricingContext);
